import React from "react";

const SigninPage = React.lazy(() =>
  import("./AppNavigation/Authentication/SignInPage")
);
const SignupPage = React.lazy(() =>
  import("./AppNavigation/Authentication/SignUpPage")
);
const VerifyOTPPage = React.lazy(() =>
  import("./AppNavigation/Authentication/VerifyOTPPage")
);
const Register2FAPage = React.lazy(() =>
  import("./AppNavigation/Authentication/Register2FAPage")
);
const CreatePasswordPage = React.lazy(() =>
  import("./AppNavigation/Authentication/CreatePasswordPage")
);
const ResetPasswordPage = React.lazy(() =>
  import("./AppNavigation/Authentication/ResetPasswordPage")
);
const ChangePasswordPage = React.lazy(() =>
  import("./AppNavigation/Authentication/ChangePasswordPage")
);
const Logout = React.lazy(() =>
  import("./AppNavigation/Authentication/components/SignIn/Logout")
);
const ResetUserAccount = React.lazy(() =>
  import("./AppNavigation/Authentication/ResetUserAccount")
);

const contactAdmin = React.lazy(() =>
  import("./AppNavigation/Authentication/contactAdmin")
);

const route = [
  {
    path: "/contact-admin",
    exact: true,
    name: "conatctAdmin",
    component: contactAdmin,
  },
  {
    path: "/auth/signin",
    exact: true,
    name: "Signin",
    component: SigninPage,
  },
  {
    path: "/auth/signup",
    exact: true,
    name: "Signup",
    component: SignupPage,
  },
  {
    path: "/auth/verify-otp",
    exact: true,
    name: "Verify OTP",
    component: VerifyOTPPage,
  },
  {
    path: "/auth/register-2fa",
    exact: true,
    name: "Register 2FA",
    component: Register2FAPage,
  },
  {
    path: "/auth/activate-user-account",
    exact: true,
    name: "Create Password",
    component: CreatePasswordPage,
  },
  {
    path: "/auth/reset-password",
    exact: true,
    name: "Reset Password",
    component: ResetPasswordPage,
  },
  {
    path: "/auth/change-password",
    exact: true,
    name: "Change Password",
    component: ChangePasswordPage,
  },
  {
    path: "/logout",
    exact: true,
    name: "Logout",
    component: Logout,
  },
  {
    path: "/auth/reset-user-account",
    exact: true,
    name: "Reset User Account",
    component: ResetUserAccount,
  },
];

export default route;
